import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

document.addEventListener("DOMContentLoaded", function () {
  const swiperElements = document.querySelectorAll(".reference-gallery-swiper");

  if (swiperElements.length > 0) {
    swiperElements.forEach((element) => {
      const slidesCount = element.querySelectorAll(".swiper-slide").length;

      const swiperConfig = {
        modules: [Navigation, Pagination, Autoplay],
        navigation: {
          nextEl: element.querySelector(".swiper-button-next"),
          prevEl: element.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: element.querySelector(".swiper-pagination"),
          clickable: true,
        },
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 700,
        grabCursor: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        // Keep a consistent configuration for all breakpoints to maintain aspect ratio
        slidesPerView: 1,
      };

      new Swiper(element, swiperConfig);
    });
  }
});
